export enum ProductTypeEnum {
  FVD_S = "Free-funds Verified Direct - Sending Solution",
  FVD_R = "Free-funds Verified Direct - Receiving Solution",
  PBIN_S = "Prime Broker Integrated Solution - Sending Solution",
  PBIN_R = "Prime Broker Integrated Solution - Receiving Solution",
  QBS_S = "Quarterly Broker Statement - Sending Solution",
  QBS_R = "Quarterly Broker Statement - Receiving Solution",
}